export default "__VITE_ASSET__Cv1p2Ceg__"